import { FormGroup } from '@angular/forms';

export function varPattern(tempContent: string, noVariables: string) {
  return (formGroup: FormGroup) => {
    const ctrlTempContent = formGroup.controls[tempContent];
    //const ctrlNoVariables = formGroup.controls[noVariables];
    var eVariables = 0;
    var teststring = ctrlTempContent.value;
    let checks: string[] = teststring.split("{");

if(teststring==""){

    ctrlTempContent.setErrors({ required: true });
}
    for (const check of checks) {  
   
      if (check[0] === "#") {     
        var regex1 = /^#[vV][aA][rR]#}$/       
        var regex2 = /^((\S|\s)*)?#[vV][aA][rR]#}?((\S|\s)*)$/    
        if (regex1.test(check) == false && regex2.test(check) == false) { 
                    
     
          ctrlTempContent.setErrors({ varPattern: true });
        }
        else if (check[5] != "}") {  
                              
                     
          ctrlTempContent.setErrors({ varPattern: true });
        } 
        // else {
        //   eVariables++;
                             
        //   if (ctrlNoVariables.value != eVariables) {    
        //     ctrlTempContent.setErrors({ varCount: true });
        //   } 
             
        //   else {
        //     ctrlTempContent.setErrors(null);
        //   }
        // }
        
       
      }
      // else if ( ctrlNoVariables.value != eVariables) {
        
      //   ctrlTempContent.setErrors({ varCount: true}); 
      // }
      // else if ((teststring.length - (eVariables * 7)) > 400) {
      //   ctrlTempContent.setErrors({ charCount: true });
      // }
      else {
        ctrlTempContent.setErrors(null);
      }
    }
  }
}